import { useState, useEffect } from "react";
import "../src/assets/components/global.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import AutoLogout from "./autologout";
import axios from "axios";
import Swal from "sweetalert2";

function Officerviewmeeting() {
  const [meetingData, setMeetingData] = useState({ meetings: [] });
  const [editData, setEditData] = useState(null);
  const [objectives, setObjectives] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const navigate = useNavigate();
  const [isEditVisible, setIsEditVisible] = useState(false);

  useEffect(() => {
    axios
      .get(
        `https://brgytracerappserver.onrender.com/viewmeeting?objectives=${objectives}`
      )
      .then((res) => {
        console.log(res.data);
        setMeetingData(res.data);
      })
      .catch((err) => console.log(err));
  }, [objectives]);

  const handleEdit = (meeting) => {
    setIsEditVisible(!isEditVisible);
    setEditData(meeting);
  };

  const handleSave = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.put(
        `https://brgytracerappserver.onrender.com/viewmeeting/${editData.meetingId}`,
        editData
      );
      if (response.data.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Meeting Updated!",
          showConfirmButton: true,
        }).then(() => {
          // Refresh the page after the user clicks "Okay"
          window.location.reload();
        });
      }
    } catch (error) {
      console.error("Error updating data:", error);
      // Handle error...
    }
  };

  const handleSearchInputChange = (e) => {
    setObjectives(e.target.value);
  };

  const handleCancel = () => {
    setObjectives("");
    setIsEditVisible(false);
    setEditData(null);
  };

  const handleClose = () => {
    navigate("/officerpage");
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) =>
      Math.min(
        prevPage + 1,
        Math.ceil(meetingData.meetings.length / rowsPerPage)
      )
    );
  };

  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentMeetings = meetingData.meetings.slice(startIndex, endIndex);

  return (
    <div className="viewmeeting-parent parent-height">
      <AutoLogout />
      <div className="container">
        <div className={`searchbox ${isEditVisible ? "edit-mode" : ""}`}>
          <div>
            <FontAwesomeIcon icon={faSearch} />
            <input
              type="text"
              placeholder="Search by Objectives"
              value={objectives}
              onChange={handleSearchInputChange}
            />
          </div>
        </div>
        {!editData && meetingData && (
          <div
            className={`datagrid-parent ${isEditVisible ? "edit-mode" : ""}`}>
            <button className="closebtn" type="button" onClick={handleClose}>
              X
            </button>
            <h1>List of Meetings</h1>
            {currentMeetings.length > 0 ? (
              <div className="datagrid-holder">
                <table>
                  <thead>
                    <tr>
                      <th>Meeting ID</th>
                      <th>Location</th>
                      <th>Objectives</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentMeetings.map((meeting) => (
                      <tr key={meeting.meetingId}>
                        <td>{meeting.meetingId}</td>
                        <td>{meeting.location}</td>
                        <td>{meeting.objectives}</td>
                        <td>{meeting.date}</td>
                        <td>{meeting.time}</td>
                        <td>{meeting.meetingstatus}</td>
                        <td
                          className="handleEdit"
                          onClick={() => handleEdit(meeting)}>
                          View
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="pagination-controls">
                  <button
                    className="pagination-button"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}>
                    Previous
                  </button>
                  <span className="pagination-info">
                    Page {currentPage} of{" "}
                    {Math.ceil(meetingData.meetings.length / rowsPerPage)}
                  </span>
                  <button
                    className="pagination-button"
                    onClick={handleNextPage}
                    disabled={
                      currentPage ===
                      Math.ceil(meetingData.meetings.length / rowsPerPage)
                    }>
                    Next
                  </button>
                </div>
              </div>
            ) : (
              <p className="noUsertext">No meetings available for display.</p>
            )}
          </div>
        )}
      </div>
      {/* Edit form */}
      {editData && (
        <div className="Updateform-parent wrap">
          <div className="updateform-holder">
            <h1>Update Meeting</h1>
            <div className="autonumbers">
              <label>Meeting ID: {editData.meetingId}</label>
            </div>
            <form className="formUpdate-boxcontainers" onSubmit={handleSave}>
              <label>Meeting Information</label>
              <div className="meetingbox-container">
                <div>
                  <label htmlFor="date">Date:</label>
                  <input
                    type="date"
                    required
                    value={editData.date}
                    onChange={(e) =>
                      setEditData({ ...editData, date: e.target.value })
                    }
                  />
                </div>
                <div>
                  <label htmlFor="location">Location:</label>
                  <input
                    type="text"
                    placeholder="Enter Location"
                    required
                    value={editData.location}
                    onChange={(e) =>
                      setEditData({ ...editData, location: e.target.value })
                    }
                  />
                </div>
                <div>
                  <label htmlFor="meetingstatus">Status:</label>
                  <select
                    value={editData.meetingstatus}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        meetingstatus: e.target.value,
                      })
                    }>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Cancelled">Cancelled</option>
                    <option value="Done">Done</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="time">Time:</label>
                  <input
                    type="time"
                    required
                    value={editData.time}
                    onChange={(e) =>
                      setEditData({ ...editData, time: e.target.value })
                    }
                  />
                </div>
                <div>
                  <label htmlFor="objectives">Objectives:</label>
                  <textarea
                    placeholder="Enter Objectives"
                    required
                    value={editData.objectives}
                    onChange={(e) =>
                      setEditData({ ...editData, objectives: e.target.value })
                    }
                  />
                </div>
              </div>
              <span className="btn-container">
                <button className="viewbtn" type="submit">
                  Update
                </button>
                <button
                  className="closebtn"
                  type="button"
                  onClick={handleCancel}>
                  X
                </button>
              </span>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Officerviewmeeting;
